<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 11V16.1716C17 16.702 17.2107 17.2107 17.5858 17.5858L20 20" stroke="var(--icon-color)" stroke-width="2"
        stroke-linecap="round" />
    <path
        d="M7 16C7 10.4772 11.4772 6 17 6C22.5228 6 27 10.4772 27 16C27 21.5228 22.5228 26 17 26C13.8856 26 11.1038 24.5763 9.26978 22.3443"
        stroke="var(--icon-color)" stroke-width="2" />
    <path
        d="M6.58397 19.376C6.78189 19.6728 7.21811 19.6728 7.41603 19.376L10.4818 14.7773C10.7033 14.4451 10.4651 14 10.0657 14H3.93426C3.53491 14 3.29672 14.4451 3.51823 14.7774L6.58397 19.376Z"
        fill="var(--icon-color)" />
</svg>
